// extracted by mini-css-extract-plugin
module.exports = {"alertStyle":"AlertGeneral_alertStyle__3_c-7","description":"AlertGeneral_description__3uaNo"};